import { render } from "./dadata.vue?vue&type=template&id=710fef7b&scoped=true"
import script from "./dadata.vue?vue&type=script&lang=js"
export * from "./dadata.vue?vue&type=script&lang=js"

import "./dadata.vue?vue&type=style&index=0&id=710fef7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710fef7b"]])

export default __exports__